import * as React from 'react';

import TileStandardLoadingHeader from './header/TileStandardLoadingHeader';
import TileStandardLoadingTabs from './tabs/TileStandardLoadingTabs';
import TileStandardLoadingContent from './content/TileStandardLoadingContent';
import TileStandardLoadingFooter from './footer/TileStandardLoadingFooter';

import '../tile-standard.scss';

import type { TileStandardSize } from 'types';

type Props = {
  tileSize: TileStandardSize
};

const TileStandardLoading = (
  {
    tileSize
  }: Props
): JSX.Element => (
  <div className="tile-standard">
    <TileStandardLoadingHeader />
    <TileStandardLoadingTabs />
    <TileStandardLoadingContent
      tileSize={tileSize}
    />
    <TileStandardLoadingFooter
      tileSize={tileSize}
    />
  </div>
);

export default TileStandardLoading;
